import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../../components/ui/Button';
import Card from '../../../../../components/ui/Card';
import LeftArrowIcon from '../../../../../components/icons/LeftArrowIcon';

export interface TrainingMetadata {
  id: string;
  title: string;
  category: string;
  description: string;
  instructor: string;
  duration: string;
  date: string;
  tags: string[];
  materials: string[];
  status: 'active' | 'completed' | 'upcoming';
  path: string;
}

export const trainingMetadata: TrainingMetadata = {
  id: '3',
  title: '3D 모델링과 3D 프린팅 연수',
  category: '3d-modeling',
  description: '3D 모델링 소프트웨어 사용법과 3D 프린팅 기술을 학습하는 연수입니다.',
  instructor: '박3D',
  duration: '5시간',
  date: '2024-02-15',
  tags: ['3D모델링', '3D프린팅', 'Tinkercad'],
  materials: ['ThreeDModelingTraining.tsx', '3D모델링기초.pdf'],
  status: 'upcoming',
  path: '/teacher-training/upcoming/ThreeDModelingTraining'
};

const ThreeDModelingTraining: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
        <Button
          leftIcon={<LeftArrowIcon width={20} height={20} />}
          onClick={() => navigate('/teacher-training')}
          variant="outline"
          style={{ marginRight: 16 }}
        >
          돌아가기
        </Button>
        <h1 style={{ fontSize: 28, fontWeight: 600, margin: 0 }}>3D 모델링과 3D 프린팅 연수</h1>
      </div>

      <Card padding="24px" style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>연수 정보</h2>
        <p style={{ margin: 0 }}>
          <strong>강사:</strong> 박3D<br/>
          <strong>기간:</strong> 2024-02-15 (5시간)<br/>
          <strong>상태:</strong> 예정
        </p>
      </Card>

      <Card padding="24px" style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>연수 내용</h2>
        <p style={{ margin: '0 0 12px' }}>
          3D 모델링 소프트웨어 사용법과 3D 프린팅 기술을 학습하는 연수입니다.
        </p>
        <p style={{ margin: 0 }}>
          • Tinkercad 기초 사용법<br/>
          • 3D 모델링 기초 개념<br/>
          • 3D 프린터 작동 원리<br/>
          • 3D 프린팅 실습<br/>
          • 교육용 3D 모델링 프로젝트
        </p>
      </Card>

      <Card padding="24px">
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>준비 자료</h2>
        <p style={{ margin: 0 }}>
          • 3D모델링기초.pdf<br/>
          • Tinkercad 계정<br/>
          • 노트북 (개인 지참)
        </p>
      </Card>
    </div>
  );
};

export default ThreeDModelingTraining;
